import { render, staticRenderFns } from "./CalendarEventCard.vue?vue&type=template&id=43da6719"
import script from "./CalendarEventCard.vue?vue&type=script&lang=js"
export * from "./CalendarEventCard.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventCard.vue?vue&type=style&index=0&id=43da6719&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports